const SitePermissionTypes = {
  F: 'Full Access',
  L: 'Limited Access',
  C: 'CERT Access',
  R: 'REM Access',
  G: 'Groups Access',
};

export default SitePermissionTypes;
